import { SystemEvent } from '../enum';
import { SystemOptionEvent, ActionOptionEvent, NoneOfTheAboveEvent, ArticleExpandedEvent, RollbackEvent } from '../types';

export function isOptionEvent (event: any): event is SystemOptionEvent {
  return event?.type === SystemEvent.LIST_OPTION_SELECTED;
}

export function isResolutionEvent (event: any): event is ActionOptionEvent {
  return event?.type === SystemEvent.USER_RESOLUTION_SELECTED;
}

export function isNoneOfTheAboveEvent (event: any): event is NoneOfTheAboveEvent {
  return event?.type === SystemEvent.NONE_OF_THE_ABOVE_SELECTED;
}

export function isArticleExpandedEvent (event: any): event is ArticleExpandedEvent {
  return event?.type === SystemEvent.ARTICLE_PREVIEW_EXPANDED;
}

export function isRollbackEvent (event: any): event is RollbackEvent {
  return event?.type === SystemEvent.USER_ROLLBACK;
}
